import BlFlexItemAv from './BlFlexItemAv.vue'

BlFlexItemAv.install = function(Vue) {
  Vue.component(BlFlexItemAv.name, BlFlexItemAv)
}

export default BlFlexItemAv
